var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"block_blockquote copy "},[_c('bg-brush',[_c('p',{domProps:{"innerHTML":_vm._s(_vm.blockquote)}})])],1)}
var staticRenderFns = []

export { render, staticRenderFns }